import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ServiceAreaService {

  private serviceAreasChanged = new Subject<void>()  
  private baseUrl = `${environment.smartPortalApiUrl}ServiceArea`;

  constructor(private httpClient: HttpClient) { }

  // Observable for components to subscribe to
  serviceAreasChanged$ = this.serviceAreasChanged.asObservable();

  getServiceNameById(serviceAreaId: string):Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/name/${serviceAreaId}`);
  }

  getServiceAreaById(serviceAreaId: string):Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/${serviceAreaId}`);
  }

  getServiceAreas() : Observable<any> {
    return this.httpClient.get(`${this.baseUrl}`);
  }

  deleteServiceArea(serviceAreaId: string): Observable<any> {
    
    return new Observable(observer => {
      this.httpClient.delete(`${this.baseUrl}/${serviceAreaId}`).subscribe({
        next: (response) => {
          this.serviceAreasChanged.next(); // Notify change
          observer.next(response);
          observer.complete();
        },
        error: (error) => observer.error(error)
      });
    });

  }

  addServiceArea(serviceArea: any): Observable<any> {
  
    return new Observable(observer => {
      this.httpClient.post(`${this.baseUrl}`, serviceArea).subscribe({
        next: (response: any) => {
          this.serviceAreasChanged.next(); // Notify change
          observer.next(response);
          observer.complete();
        },
        error: (error: any) => observer.error(error)
      });
    });  
  }

  updateServiceArea(serviceAreaId: string, serviceArea: any): Observable<any> {

    return new Observable(observer => {
      this.httpClient.put(`${this.baseUrl}/${serviceAreaId}`, serviceArea).subscribe({
        next: (response) => {
          this.serviceAreasChanged.next(); // Notify change
          observer.next(response);
          observer.complete();
        },
        error: (error) => observer.error(error)
      });
    });
  }

}
